
const locale = {
  // --- Vuetify Pro style keys (full coverage) ---
  'editor.remove': 'Remove',
  'editor.words': 'WORDS',
  'editor.characters': 'CHARACTERS',
  'editor.default': 'default',
  'editor.size.small.tooltip': 'Small',
  'editor.size.medium.tooltip': 'Medium',
  'editor.size.large.tooltip': 'Cover',
  'editor.bold.tooltip': 'Bold',
  'editor.italic.tooltip': 'Italic',
  'editor.underline.tooltip': 'Underline',
  'editor.strike.tooltip': 'Strike',
  'editor.color.tooltip': 'Color',
  'editor.highlight.tooltip': 'Highlight',
  'editor.heading.tooltip': 'Headings',
  'editor.heading.h1.tooltip': 'Heading 1',
  'editor.heading.h2.tooltip': 'Heading 2',
  'editor.heading.h3.tooltip': 'Heading 3',
  'editor.heading.h4.tooltip': 'Heading 4',
  'editor.heading.h5.tooltip': 'Heading 5',
  'editor.heading.h6.tooltip': 'Heading 6',
  'editor.paragraph.tooltip': 'Paragraph',
  'editor.textalign.tooltip': 'Align',
  'editor.textalign.left.tooltip': 'Left',
  'editor.textalign.center.tooltip': 'Center',
  'editor.textalign.right.tooltip': 'Right',
  'editor.textalign.justify.tooltip': 'Justify',
  'editor.fontFamily.tooltip': 'Font family',
  'editor.fontSize.tooltip': 'Font size',
  'editor.fontWeight.tooltip': 'Font weight',
  'editor.letterSpacing.tooltip': 'Letter spacing',
  'editor.letterSpacing.label': 'Letter spacing',
  'editor.letterSpacing.apply': 'Apply',
  'editor.letterSpacing.reset': 'Reset',
  'editor.superscript.tooltip': 'Superscript',
  'editor.subscript.tooltip': 'Subscript',
  'editor.bulletlist.tooltip': 'Bullet List',
  'editor.orderedlist.tooltip': 'Ordered List',
  'editor.tasklist.tooltip': 'Task List',
  'editor.indent.tooltip': 'Indent',
  'editor.outdent.tooltip': 'Outdent',
  'editor.link.tooltip': 'Link',
  'editor.link.unlink.tooltip': 'Unlink',
  'editor.link.open': 'Open link',
  'editor.link.dialog.title': 'Insert link',
  'editor.link.dialog.link': 'link',
  'editor.link.dialog.openInNewTab': 'Open in new tab',
  'editor.link.dialog.button.apply': 'apply',
  'editor.markdownTheme.tooltip': 'Theme',
  'editor.image.tooltip': 'Image',
  'editor.image.float.left.tooltip': 'Float left',
  'editor.image.float.none.tooltip': 'Float none',
  'editor.image.float.right.tooltip': 'Float right',
  'editor.image.dialog.title': 'Insert image',
  'editor.image.dialog.tab.url': 'url',
  'editor.image.dialog.tab.upload': 'upload',
  'editor.image.dialog.form.link': 'Link',
  'editor.image.dialog.form.alt': 'Alt',
  'editor.image.dialog.form.aspectRatio': 'Lock original aspect ratio',
  'editor.image.dialog.form.file': 'File',
  'editor.image.dialog.button.apply': 'apply',
  'editor.video.tooltip': 'Video',
  'editor.video.dialog.title': 'Insert video',
  'editor.video.dialog.link': 'link',
  'editor.video.dialog.button.apply': 'apply',

  // Table (this fixes your dropdown labels)
  'editor.table.tooltip': 'Table',
  'editor.table.menu.insert_table': 'Insert Table',
  'editor.table.menu.insert_table.with_header_row': 'With header row',
  'editor.table.menu.add_column_before': 'Add Column Before',
  'editor.table.menu.add_column_after': 'Add Column After',
  'editor.table.menu.delete_column': 'Delete Column',
  'editor.table.menu.add_row_before': 'Add Row Before',
  'editor.table.menu.add_row_after': 'Add Row After',
  'editor.table.menu.delete_row': 'Delete Row',
  'editor.table.menu.merge_or_split_cells': 'Merge Or Split Cells',
  'editor.table.menu.delete_table': 'Delete Table',

  'editor.blockquote.tooltip': 'Blockquote',
  'editor.horizontalrule.tooltip': 'Horizontal Rule',
  'editor.code.tooltip': 'Code',
  'editor.codeblock.tooltip': 'Code Block',
  'editor.clear.tooltip': 'Clear Format',
  'editor.undo.tooltip': 'Undo',
  'editor.redo.tooltip': 'Redo',
  'editor.fullscreen.tooltip.fullscreen': 'Fullscreen',
  'editor.fullscreen.tooltip.exit': 'Fullscreen Exit',

  // --- Back-compat keys used elsewhere in your app (kept so nothing breaks) ---
  bold: 'Bold',
  italic: 'Italic',
  underline: 'Underline',
  strike: 'Strikethrough',
  code: 'Code',
  heading: 'Heading',
  bulletList: 'Bullet List',
  orderedList: 'Ordered List',
  blockquote: 'Blockquote',
  link: 'Link',
  image: 'Image',
  table: 'Table',
  undo: 'Undo',
  redo: 'Redo',
  heading1: 'Heading 1',
  heading2: 'Heading 2',
  heading3: 'Heading 3',
  heading4: 'Heading 4',
  heading5: 'Heading 5',
  heading6: 'Heading 6',
  addColumnBefore: 'Add column before',
  addColumnAfter: 'Add column after',
  deleteColumn: 'Delete column',
  addRowBefore: 'Add row before',
  addRowAfter: 'Add row after',
  deleteRow: 'Delete row',
  deleteTable: 'Delete table',
  openLink: 'Open link',
  editLink: 'Edit link',
  removeLink: 'Remove link',
  addImage: 'Add image',
  clearFormatting: 'Clear formatting',
  horizontalRule: 'Horizontal rule',
  codeBlock: 'Code block',
  placeholder: 'Type something...'
}

export default locale
